import React from 'react'
import {toast, ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const AlertContainer = () => {
    return (
        <ToastContainer
            position={toast.POSITION.BOTTOM_RIGHT}
            autoClose={3500}
            hideProgressBar={false}
            preventDuplicates={true}
        />
    )
}

export default AlertContainer
